import { POPUP_SECTIONS } from "../../constant/constant.js";
import { isPitchLayoutSection } from "../../../shared/pitch-layout-display.js";
import {
  ensureProductRecommendationBrandAttribution,
  ensureProductRecommendationTrustBadges,
  getProductRecommendationLayoutOptionsFromPopup,
} from "../../../shared/product-recommendation-popup-schema.js";

/**
 * @param {object[]} sections
 */
export function indexProductRecommendationSections(sections = []) {
  const list = Array.isArray(sections) ? [...sections] : [];
  ensureProductRecommendationTrustBadges(list);
  ensureProductRecommendationBrandAttribution(list);

  const findByType = (type) => {
    const index = list.findIndex((s) => s?.type === type);
    if (index < 0) return null;
    return { section: list[index], index };
  };

  const findByRole = (role) => {
    const index = list.findIndex((s) => s?.setting?.role === role);
    if (index < 0) return null;
    return { section: list[index], index };
  };

  const findPitchLine = () => {
    const index = list.findIndex((s) => isPitchLayoutSection(s));
    if (index < 0) return null;
    return { section: list[index], index };
  };

  const pitchLine = findPitchLine();

  return {
    sections: list,
    countdown: findByType(POPUP_SECTIONS.COUNTDOWN),
    pitchLine,
    headline: pitchLine
      ? null
      : findByRole("headline") ||
        list
          .map((section, index) => ({ section, index }))
          .find(({ section }) => section?.type === POPUP_SECTIONS.TEXT) ||
        null,
    product: findByType(POPUP_SECTIONS.PRODUCT),
    trust:
      findByType(POPUP_SECTIONS.TRUST_BADGES) || findByRole("trust") || null,
    brandAttribution:
      findByType(POPUP_SECTIONS.BRAND_ATTRIBUTION) ||
      findByRole("brandAttribution") ||
      null,
  };
}

/**
 * @param {object | null | undefined} popupData
 */
export function getProductRecommendationLayoutOptions(popupData) {
  return getProductRecommendationLayoutOptionsFromPopup(popupData);
}

export { getProductRecommendationLayoutOptionsFromPopup };
